import {ScriptableContext} from 'chart.js';
import {Context} from 'chartjs-plugin-datalabels';

export class ChartTools {
  static matchToVarianceSign(returnValues: { negative: string, positive: string }) {
    return (ctx: Context | ScriptableContext<'bar'>) => {
      const value = ctx.dataset.data[ctx.dataIndex] as [number, number];
      return value[0] < value[1] ? returnValues.negative : returnValues.positive;
    };
  }

}
